import React, { useState } from "react";
import {
  Box,
  Button,
  Text,
} from "@chakra-ui/react";
import { FiTrash2 } from "react-icons/fi";
import { SelectWithLabel, SelectOption } from "newui/components/ui/InputWithLabel/SelectWithLabel";

interface DocumentBulkActionsBarProps {
  selectedCount: number;
  categoryOptions: SelectOption[];
  onBulkDelete: () => void;
  onBulkChangeCategory: (categoryId: number) => void;
}

export const DocumentBulkActionsBar = ({
  selectedCount,
  categoryOptions,
  onBulkDelete,
  onBulkChangeCategory,
}: DocumentBulkActionsBarProps) => {
  const [selectedCategory, setSelectedCategory] = useState<SelectOption | null>(null);

  if (selectedCount === 0) {
    return null;
  }

  const handleCategoryChange = (option: SelectOption | SelectOption[] | null) => {
    if (option && !Array.isArray(option)) {
      setSelectedCategory(option);
      onBulkChangeCategory(Number(option.value));
      setSelectedCategory(null);
    }
  };

  return (
    <Box
      position="sticky"
      bottom={0}
      zIndex={10}
      bg="blue.600"
      color="white"
      px={4}
      py={3}
      display="flex"
      alignItems="center"
      gap={4}
      borderRadius="md"
      shadow="lg"
      data-testid="document-bulk-actions-bar"
    >
      <Text fontWeight="semibold" fontSize="sm">
        {selectedCount} {selectedCount === 1 ? "document" : "documents"} selected
      </Text>
      <Box flex={1} />
      <Box minW="200px">
        <SelectWithLabel
          options={categoryOptions}
          value={selectedCategory}
          onChange={handleCategoryChange}
          placeholder="Change category..."
          noLabel
          testId="bulk-change-category-select"
        />
      </Box>
      <Button
        leftIcon={<FiTrash2 />}
        size="sm"
        colorScheme="red"
        variant="solid"
        onClick={onBulkDelete}
        data-testid="bulk-delete-btn"
      >
        Delete Selected
      </Button>
    </Box>
  );
};
